interface Authentication {
  credential: string;
}

type AuthenticationResponse = Authentication | unknown;

/**
 * @see https://developers.google.com/identity/gsi/web/guides/overview
 */
interface Google {
  accounts: {
    id: {
      /**
       * @see https://developers.google.com/identity/gsi/web/reference/js-reference#google.accounts.id.initialize
       */
      initialize: (config: {
        client_id: string;
        use_fedcm_for_prompt: boolean;
        callback: (res: AuthenticationResponse) => void;
      }) => void;

      /**
       * @see https://developers.google.com/identity/gsi/web/reference/js-reference#google.accounts.id.renderButton
       */
      renderButton: (
        el: HTMLElement,
        config: {
          type?: 'icon' | 'standard';
          theme?: 'outline' | 'filled_blue' | 'filled_black';
          size?: 'large' | 'medium' | 'small';
          text?: 'signin_with' | 'signup_with' | 'continue_with' | 'signin';
          shape?: 'rectangular' | 'pill' | 'circle' | 'square';
          logo_alignment?: 'left' | 'center';
          width?: string | number; // 240-400
          locale?: string;
          click_listener?: () => void;
        }
      ) => void;
    };
  };
}

export type WindowGoogle = Google | unknown;

export const isGoogleValid = (google: WindowGoogle): google is Google =>
  typeof (google as Google).accounts === 'object' &&
  typeof (google as Google).accounts.id === 'object' &&
  typeof (google as Google).accounts.id.initialize === 'function' &&
  typeof (google as Google).accounts.id.renderButton === 'function';

export const isAuthenticationValid = (
  auth: AuthenticationResponse
): auth is Authentication =>
  typeof (auth as Authentication) === 'object' &&
  typeof (auth as Authentication).credential === 'string' &&
  (auth as Authentication).credential.length > 25;
